import { defineMessages } from 'react-intl';

export const evidencePreviewCardMessages = defineMessages({
  generatingAnswer: {
    defaultMessage: 'Generating answer…',
    id: 'w7sRwA/aBL',
    description:
      'Status shown in the Evidence answer preview while the model is still responding',
  },
  searchingForQuery: {
    defaultMessage: 'Searching for: “{query}”',
    id: 'thvS89m+5Q',
    description:
      'Fallback preview text when no answer is available yet; query is truncated user question text',
  },
  readMoreInEvidence: {
    defaultMessage: 'Read more in Evidence →',
    id: 'Kb1PwHqsGb',
    description:
      'Link hint when the preview text is truncated and more detail is available in Evidence',
  },
  openInEvidence: {
    defaultMessage: 'Open in Evidence →',
    id: 'sy8Irkg4GN',
    description:
      'Link hint when the full preview fits but the user can open the answer in Evidence',
  },
  citationBadge: {
    defaultMessage: '[{number}]',
    id: 'pmA2RMaYV0',
    description: 'Bracketed citation index shown on an Evidence preview source badge',
  },
});
